import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_VENDORS: createAsyncActionConstants('FETCH_VENDORS'),
    RESET_VENDORS: createAsyncActionConstants('RESET_VENDORS')
}